/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import type { TranslatorProps } from 'react-i18next';
import Loading from 'components/Loading/Loading';
import Form from 'forms/_.extend';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import ChangeAssetsLocationsSuccessForm from './ChangeAssetsLocationsSuccessForm';
import ChangeAssetsLocationsErrorForm from './ChangeAssetsLocationsErrorForm';
import ChangeAssetsLocationsForm from './ChangeAssetsLocationsForm';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  assetStore: Object,
};

@translate()
@inject('actionDrawerStore', 'assetStore')
@observer
export default class ChangeMultipleLocation extends React.Component<*> {
  componentWillUnmount() {
    this.props.assetStore.clearDetails();
  }

  createForm = () => {
    const { t, actionDrawerStore, assetStore }: TypeProps = this.props;

    const assets = this.props.formData;

    const fields: Array<Object> = [
      {
        name: 'changeLocation',
        label: t('general:actions.change_location_to'),
        fields: [
          {
            name: 'location',
            label: t('general:location'),
            rules: 'required|string',
            value: this.value,
            extra: {
              hierarchy: [
                {
                  name: 'company',
                  label: t('general:company'),
                  rules: 'string|min:8|max:32',
                  type: 'company',
                  placeholder: t('general:company'),
                  value: null,
                },
                {
                  name: 'country',
                  type: 'country',
                  placeholder: t('general:country'),
                  value: null,
                },
                {
                  name: 'site',
                  type: 'location',
                  placeholder: t('general:locations.labels.site'),
                  value: null,
                },
                {
                  name: 'building',
                  type: 'location',
                  placeholder: t('general:locations.labels.building_transport'),
                  value: null,
                },
                {
                  name: 'room',
                  type: 'location',
                  placeholder: t('general:locations.labels.lab_room'),
                  value: null,
                },
                {
                  name: 'workspace',
                  type: 'location',
                  placeholder: t('general:locations.labels.system_workspace'),
                  value: null,
                },
              ],
            },
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        if (assets.length > 0) {
          assetStore.loadAssets(assets.map(item => item.asset_id));
        }
      },
      onSuccess(data: Object) {
        const { location }: Object = data.values().changeLocation;

        assets.forEach(asset => {
          actionDrawerStore.changeAssetLocation(asset.asset_id, {
            asset_ids: [asset.asset_id],
            location_id: location,
          });
        });

        assetStore.clearDetails();
      },
    };
    return new Form(
      { fields },
      {
        hooks,
        name: 'Multiple',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const title = t('general:actions.change_location');

    const assets = this.props.formData;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <ChangeAssetsLocationsErrorForm />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <ChangeAssetsLocationsSuccessForm />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <ChangeAssetsLocationsForm renderMultiple={true} assets={assets} form={this.createForm()} />
      </div>
    );
  }
}
